<template>
<div v-if="spin" class="spinner-container">
  <div class="spinner-content">
    <div class="spinner-message">
      <h5>
        <v-progress-circular v-if="!loadingState.user" indeterminate class="primary--text"/>
        <v-icon large class="green--text text--darken-2" v-if="loadingState.user">done</v-icon> Caricamento utente....
      </h5>
      <h5>
        <v-progress-circular v-if="!loadingState.pvi" indeterminate class="primary--text"/>
        <v-icon large class="green--text text--darken-2" v-if="loadingState.pvi">done</v-icon> Caricamento prodotti....
      </h5>
      <h5>
        <v-progress-circular v-if="!loadingState.menu" indeterminate class="primary--text"/>
        <v-icon large class="green--text text--darken-2" v-if="loadingState.menu">done</v-icon> Caricamento menu....
      </h5>
      <h5>
        <v-progress-circular v-if="!loadingState.listini" indeterminate class="primary--text"/>
        <v-icon large class="green--text text--darken-2" v-if="loadingState.listini">done</v-icon> Caricamento listini....
      </h5>
      <h5>
        <v-progress-circular v-if="!loadingState.tags" indeterminate class="primary--text"/>
        <v-icon large class="green--text text--darken-2" v-if="loadingState.tags">done</v-icon> Caricamento gruppi....
      </h5>
      <h5>
        <v-progress-circular v-if="!loadingState.tavoli" indeterminate class="primary--text"/>
        <v-icon large class="green--text text--darken-2" v-if="loadingState.tavoli">done</v-icon> Caricamento tavoli....
      </h5>
      <h5>
        <v-progress-circular v-if="!loadingState.tavoli" indeterminate class="primary--text"/>
        <v-icon large class="green--text text--darken-2" v-if="loadingState.terminals">done</v-icon> Caricamento terminali....
      </h5>
      <h5>
        <v-progress-circular v-if="!loadingState.tavoli" indeterminate class="primary--text"/>
        <v-icon large class="green--text text--darken-2" v-if="loadingState.operators">done</v-icon> Caricamento operatori....
      </h5>
      <h5>
        <v-progress-circular v-if="!loadingState.tavoli" indeterminate class="primary--text"/>
        <v-icon large class="green--text text--darken-2" v-if="loadingState.operators_rights">done</v-icon> Caricamento diritti operatori....
      </h5>
    </div>
  </div>
</div>
</template>

<script>
/**
 * Indicatore di stato di caricamento delle risorse iniziali
 * @module components/common/Spinner
 */
export default {
  name: 'spinner',
  data () {
    return {
    }
  },
  computed: {
    loadingState () {
      return this.$store.getters.load_state
    }
  },
  props: ['spin']
}
</script>

<style lang="scss" scoped>
.spinner-message {
  padding: 1px 4px;
  border-radius: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Spinner.vue